import { defineType } from "sanity";

export default defineType({
  name: "cruiseLandProgramme",
  title: "Cruise Land Programme",
  type: "object",
  preview: {
    select: {
      name: "landProgramme.name",
      code: "landProgramme.code",
      image: "landProgramme.image"
    },
    prepare({ name, code, image }) {
      return {
        title: name,
        subtitle: code,
        media: image
      };
    }
  },
  fields: [
    {
      title: "Land Programme",
      name: "landProgramme",
      type: "reference",
      to: [{ type: "landProgramme" }],
      readOnly: true,
      weak: true
    },
    {
      name: "prices",
      title: "Prices",
      type: "multiCurrencyAmount",
      readOnly: true
    }
  ]
});
